module.exports = __webpack_public_path__ + "statics/img/yhz2.e0bdf884.png";